import { render, staticRenderFns } from "./PopularProducts.vue?vue&type=template&id=72c1128e&scoped=true"
import script from "./PopularProducts.vue?vue&type=script&lang=js"
export * from "./PopularProducts.vue?vue&type=script&lang=js"
import style0 from "./PopularProducts.vue?vue&type=style&index=0&id=72c1128e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c1128e",
  null
  
)

export default component.exports